import { render, staticRenderFns } from "./resto_livraison.vue?vue&type=template&id=8a18890a&scoped=true&"
import script from "./resto_livraison.vue?vue&type=script&lang=js&"
export * from "./resto_livraison.vue?vue&type=script&lang=js&"
import style0 from "./resto_livraison.vue?vue&type=style&index=0&id=8a18890a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a18890a",
  null
  
)

export default component.exports